export enum FirebaseNotificationsState {
  INITIALIZING = 'initializing', // initial state before checking permissions and service worker
  UNDEFINED = 'undefined', // unknown browser support
  ERROR = 'error', // an error occurred while setting up notifications
  UNSUPPORTED = 'unsupported', // service workers or notifications not supported by the browser
  GRANTED = 'granted', // user granted permission
  DENIED = 'denied', // user denied permission
  DEFAULT = 'default', // user dismissed permission prompt without making a choice
}